module.exports = __webpack_public_path__ + "2-50.jpg?fd5adcfd71f54a49d2d2e22fb27fd77e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-50.jpg
// module id = 127
// module chunks = 0